import { hMacAjax } from 'grt-tool-lib-front';
import { baseURL } from '@/httpService/API';
// const baseUserURL = `${baseURL}/grt-user-service`;
const baseCenterURL = `${baseURL}/grt-user-center-service`;
//分班
export const divideClass = (data) => {
    return hMacAjax.post(baseCenterURL + '/user/business/v1/class/allocation', data);
};
//获取班级列表
export const getClassList = (data) => {
    return hMacAjax.get(baseCenterURL + '/user/business/v1/class/list', data);
};
// 是否项目学员校验
export const projectCheck = (data) => {
    return hMacAjax.post(baseCenterURL + '/user/learn-business/v1/project-check', data);
};
//章节列表-公开
export const getOpenChapterList = (data) => {
    return hMacAjax.post(baseCenterURL + '/open/business/chapter/list', data);
};
//章节列表-学员
export const getChapterList = (data) => {
    return hMacAjax.post(baseCenterURL + '/user/chapter/v1/list-version', data);
};
//获取公开模板列表 templateId, categoryid, pageNum, pageSize
export const getTempleteList = async (data) => {
    return await hMacAjax.post(baseCenterURL + '/open/business/v1/app/page', data);
};
//用户
export const getUserTempleteList = async (data) => {
    return await hMacAjax.post(baseCenterURL + '/user/learn-business/v1/page', data);
};
// 课程详情
export const getCourseDetail = (id, data) => {
    return hMacAjax.get(baseCenterURL + `/open/business/v1/app/${id}`, data);
};
// 讲师介绍
export const getLecturerDetail = (id) => {
    return hMacAjax.get(baseCenterURL + `/open/business/teacher/${id}`);
};
//课程学习人数 business_id template_id
export const getStudentNum = (data) => {
    return hMacAjax.get(baseCenterURL + '/open/business/v1/learn-num', data);
};
// 收藏接口
export const addCollect = (data) => {
    return hMacAjax.post(baseCenterURL + '/user/favorite/add', data);
};
// 取消收藏接口
export const cancelCollect = (data) => {
    return hMacAjax.post(baseCenterURL + '/user/favorite/cancel', data);
};
//学员-查询资源文件表详情
export const getResourceFile = (id) => {
    return hMacAjax.get(baseCenterURL + `/open/document/v1/${id}`);
};

//播放token
export const getResourceFileToken = (id) => {
    return hMacAjax.get(baseCenterURL + `/user/document/v1/vod/asset-token/${id}`);
};
//获取播放进度
export const getProgress = (data) => {
    return hMacAjax.get(baseCenterURL + '/user/score-summary/playProgress', data);
};

//检查是否多端播放
export const canPlayFile = (data) => {
    return hMacAjax.get(baseCenterURL + '/user/learn-business/v1/start-playing', data);
};

//检查客户端时间
export const checkTime = (data) => {
    return hMacAjax.get(baseCenterURL + '/user/learn-business/v1/date-check', data);
};

//公开邀请学员检查
export const inviteCheck = (data) => {
    return hMacAjax.post(baseCenterURL + '/open/business-invite/v1/check', data);
};

export const studentCheck = (data) => {
    return hMacAjax.post(baseCenterURL + '/business-invite/student/v1/check', data);
};

export const inviteStudent = (data) => {
    return hMacAjax.post(baseCenterURL + '/business-invite/student/v1', data);
};

//获取学员完善信息
export const improveInfoDetail = (data) => {
    return hMacAjax.post(baseCenterURL + '/open/student/v1/student/improve/detail', data);
};

//学员完善信息提交
export const submitImproveInfo = (data) => {
    return hMacAjax.post(baseCenterURL + '/open/student/v1/student/improve', data);
};

//学习卡加入业务学员（登录状态下非业务学员）
export const invitationCodeStudent = (data) => {
    return hMacAjax.post(baseCenterURL + '/business-invite/student/v1', data);
};

// 试听配置
export const getTrialListeningReq = (params) => {
    return hMacAjax.get(baseCenterURL + '/open/business/config/detail', params);
};

//会议列表
export const getUserTempleteMeetingList = async (data) => {
    return await hMacAjax.post(baseCenterURL + '/user/learn-business/v1/page', data);
};

//查询会议设置
export const getUserMeetingConfig = async (id) => {
    return await hMacAjax.get(baseCenterURL + `/user/meeting/config/${id}`);
};